export default "__VITE_ASSET__Cpx81l4___"